import axios from 'axios';
import store from '../../redux/store';
import { config } from '../../config';
import { request_with_retry } from '../../helpers/request_retry';

const readRequestOptions = {
    timeout: 12000
};

const get_users_with_roles = async () => {
    try {
        return await request_with_retry(() => {
            return axios.get(`${config.DOLORES_BACKEND_URL}/admins/users-with-roles`, readRequestOptions);
        });
    } catch (error) {
        console.error('[Error | getUsersWithRoles] > ', error);
        return false;
    }
};

const get_settings = (id) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.ERISED_BACKEND_URL}/users/${id}/getSettings`)
            .then(res => resolve(res))
            .catch(() => {
                resolve(false);
            });
    });
};

const get_user_images = (userId) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.ERISED_BACKEND_URL}/users/getImages?userId=${userId}`)
            .then(res => resolve(res))
            .catch(() => {
                resolve(false);
            });
    });
};

const save_preferences = (userId) => {
    const preferences = store.getState()?.preferences || {};
    const resolvedUserId = userId || store.getState()?.user?.user?.sub || '';

    return axios.post(`${config.ERISED_BACKEND_URL}/users/savePreferences`, {
        data: {
            userId: resolvedUserId,
            theme: preferences.theme || localStorage.getItem('theme') || 'light',
            language: preferences.language || localStorage.getItem('language') || 'en',
            region: store.getState()?.country || ''
        }
    }).catch(() => false);
};

const get_preferences = (userId) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.ERISED_BACKEND_URL}/users/getPreferences?userId=${userId}`)
            .then(res => {
                resolve({
                    theme: res?.data?.data?.theme ? res.data.data.theme : false,
                    lang: res?.data?.data?.language ? res.data.data.language : false,
                    region: res?.data?.data?.region ? res.data.data.region : false
                });
            })
            .catch(() => {
                resolve(false);
            });
    });
};

export {
    get_users_with_roles,
    get_settings,
    get_user_images,
    get_preferences,
    save_preferences
};
